const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Anmelden",
    signUp: "Registrieren",
    signInShort: "Anmelden",
    signUpShort: "Registrierung",
  },
  landing: {
    firstMessageBefore: "Sieh, ",
    firstMessageHighlight: "wo deine Freunde",
    firstMessageAfter: " heute waren.",
    secondMessageBefore: "Spiele mit deinen Freunden in der ",
    secondMessageHighlight: "realen Welt.",
  },
  search: {
    placeholder: "Finde, was du willst...",
    ariaLabel: "Suchen",
  },
  feed: {
    untitled: "Ohne Titel",
    channelFallback: "Kanal",
    todayMomentsSubtitle: "Entdecke, wo deine Freunde ihre besten Momente verbringen",
    todayMomentsLabel: "Dein Moment",
    friendSpotsSection: "Die Spots deiner Freunde",
    spotDistancePrefix: "In",
    loadMoreSpots: "Mehr sehen",
    nearbyExploreTitle: "Entdecke in deiner Nähe",
    nearbyTreasureHuntsTitle: "IRL-Quests",
    treasureHuntLabel: "IRL-Quest",
    treasureHuntUnlockOnSite: "IRL-Quest vor Ort freischalten",
    unlockOnSite: "Vor Ort freischalten",
    distanceAway: "{{distance}} entfernt",
    mapFoundContent: "Inhalt gefunden",
    mapNoExploreFound: "Kein Explore gefunden",
    openAction: "Öffnen",
    startAction: "Starten",
    trendingNow: "Sie sind gerade im Trend",
    categoriesTitle: "Kategorien",
  },
  video: {
    gameAvailable: "Spiel in diesem Video verfügbar",
    clickToPlay: "Zum Spielen klicken",
    tapToPlay: "Tippen zum Spielen",
    home: "Start",
    signInToLike: "Zum Liken anmelden",
    signInToComment: "Zum Kommentieren anmelden",
    exploreOnlyFromMap: "Explores lassen sich nur über die Karte oder ihren eigenen Bereich öffnen.",
    enableLocationForExplore: "Aktiviere deinen Standort, um diesen Explore-Inhalt zu sehen.",
    noAnswer: "Keine Antwort",
    youtubeLikesUnavailable: "Likes sind bei YouTube-Videos nicht verfügbar",
    addComment: "Kommentar hinzufügen...",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Kurzantwort",
  },
  badges: {
    wood: "Holz",
    bronze: "Bronze",
    silver: "Silber",
    gold: "Gold",
    uranium: "Uran",
  },
  notifications: {
    title: "Benachrichtigungen",
    loading: "Benachrichtigungen werden geladen...",
    empty: "Zurzeit keine Benachrichtigungen.",
    signInRequired: "Melde dich an, um deine Benachrichtigungen zu sehen.",
    loadError: "Benachrichtigungen konnten nicht geladen werden.",
    userFallback: "Nutzer",
  },
  searchFeed: {
    all: "Alle",
    spots: "Spots",
    videos: "Videos",
    explores: "Explores",
    treasureHunts: "IRL-Quests",
    resultsFor: "Ergebnisse für:",
    noResults: "Keine Ergebnisse gefunden.",
    availableAt: "Verfügbar bei {{distance}}",
    unlockOnSite: "Vor Ort freischalten",
    channels: "Kanäle",
  },
  map: {
    filters: {
      subscriptions: "Abonnements",
      private: "Privat",
      all: "Alle",
    },
    myPosition: "Meine Position",
    searchPlacePlaceholder: "Suche nach Paris, Montmartre...",
    geolocationUnavailable: "Die Geolokalisierung ist auf diesem Gerät nicht verfügbar.",
    enableLocationNearby: "Erlaube die Geolokalisierung, um Inhalte in der Nähe freizuschalten.",
    currentPositionUnavailable: "Deine aktuelle Position konnte nicht abgerufen werden.",
    googleMapsLoadError: "Google Maps konnte nicht geladen werden.",
    loadExploreSubscriptionsError: "Explore-Abonnements konnten nicht geladen werden.",
    loadExplorePointsError: "Explore-Punkte konnten nicht geladen werden.",
    loadExploreMapError: "Die Explore-Karte konnte nicht geladen werden.",
    loadPointDetailError: "Die Punktdetails konnten nicht geladen werden.",
    loadTreasureHuntError: "Diese IRL-Quest konnte nicht geladen werden.",
    noPlaceFound: "Für diese Suche wurde kein Ort gefunden.",
    placeNotFound: "Ort nicht gefunden.",
    enableCurrentPositionBeforeSaving: "Aktiviere deine aktuelle Position, bevor du einen Punkt speicherst.",
    savePositionError: "Diese Position konnte nicht gespeichert werden.",
    positionUsableForContent: "Diese Position kann für Inhalte verwendet werden",
    positionSaveFailed: "Position konnte nicht gespeichert werden.",
    stopTreasureHuntError: "Diese IRL-Quest konnte nicht gestoppt werden.",
    gpsPointLabelPlaceholder: "GPS-Punktbezeichnung",
  },
  explore: {
    signInToInteract: "Melde dich an, um mit diesem Explore zu interagieren.",
    likeError: "Dieses Explore konnte nicht gelikt werden.",
    addCommentError: "Der Kommentar konnte nicht hinzugefügt werden.",
    addReplyError: "Die Antwort konnte nicht hinzugefügt werden.",
    likeCommentError: "Dieser Kommentar konnte nicht gelikt werden.",
    requestSent: "Anfrage gesendet",
  },
  profileMenu: {
    title: "Qubiq-Profil",
    signedOutDescription:
      "Melde dich an, um auf dein Profil, deine Benachrichtigungen sowie die Spieler- und Creator-Funktionen von Qubiq zuzugreifen.",
    myProfile: "Mein Profil",
    editProfile: "Mein Profil bearbeiten",
    notifications: "Benachrichtigungen",
    notificationsWithCount: "Benachrichtigungen ({{count}})",
    friendGroups: "Freundesgruppen",
    inviteFriends: "Meine Freunde einladen",
    inviteFriendsDesktop: "Meine Freunde einladen (+20 Qubs-Token)",
    createOnQubiq: "Auf Qubiq erstellen",
    contactUs: "Kontaktieren",
    creatorWelcomeTitle: "Du bist jetzt Qubiq Creator 💛",
    creatorWelcomeDesktop:
      "Klicke auf die Qubiq Studio-Schaltfläche, um deine Videos und Explores hochzuladen und deine Spiele und Quests zu konfigurieren.",
    creatorWelcomeMobile:
      "Tippe auf die Qubiq Studio-Schaltfläche, um deine Videos und Explores hochzuladen und deine Spiele und Quests zu konfigurieren.",
    contactCreatorMessage:
      "Schreib mir an damien@qubiq.tv. Ich antworte dir so schnell wie möglich 💛",
    legalInfo: "Rechtliche Informationen",
    language: "Sprache",
    languageDescription: "Wähle die auf Qubiq verwendete Sprache aus.",
    cookiesAndConsent: "Cookies und Einwilligung",
    manageCookies: "Meine Cookies verwalten",
    openLanguageMenu: "Sprachauswahl öffnen",
  },
  friendGroups: {
    title: "Freundesgruppen",
    subtitle: "Erstelle eine Gruppe und lade andere Spieler ein, dir beizutreten.",
    signInRequired: "Melde dich an, um auf deine Freundesgruppen zuzugreifen.",
    loadError: "Die Freundesgruppen konnten nicht geladen werden.",
    detailLoadError: "Diese Freundesgruppe konnte nicht geladen werden.",
    create: "+ Gruppe erstellen",
    createDialogTitle: "Freundesgruppe erstellen",
    renameDialogTitle: "Gruppe umbenennen",
    groupNameLabel: "Gruppenname",
    groupNamePlaceholder: "Z. B. Team Paris",
    confirmCreate: "Gruppe erstellen",
    confirmRename: "Speichern",
    createError: "Diese Gruppe konnte nicht erstellt werden.",
    renameError: "Diese Gruppe konnte nicht umbenannt werden.",
    duplicateNameError: "Dieser Gruppenname existiert bereits.",
    myGroups: "Meine Gruppen",
    backToGroups: "Zurück zu den Gruppen",
    empty: "Du hast noch keine Freundesgruppen.",
    untitledGroup: "Unbenannte Gruppe",
    groupCounts: "{{count}} Freund(e) · {{pending}} ausstehende Anfrage(n)",
    incomingInvitesTitle: "Erhaltene Einladungen",
    invitedBy: "Eingeladen von {{username}}",
    accept: "Bestätigen",
    refuse: "Abbrechen",
    refuseInviteAction: "Ablehnen",
    acceptInviteError: "Diese Einladung konnte nicht angenommen werden.",
    refuseInviteError: "Diese Einladung konnte nicht abgelehnt werden.",
    selectGroup: "Wähle eine Gruppe",
    selectGroupDescription: "Wähle links eine Gruppe aus, um ihre Freunde zu sehen und neue Einladungen zu versenden.",
    searchUsersTitle: "Freund(e) hinzufügen",
    searchPlayersPlaceholder: "Spieler suchen",
    searchResults: "Ergebnisse",
    searching: "Suche läuft...",
    noSearchResults: "Kein Benutzer gefunden.",
    membersTitle: "Gruppenmitglieder",
    noMembersYet: "Noch keine Mitglieder.",
    addUserDialogTitle: "Zu meiner Freundesgruppe hinzufügen?",
    addUserDialogBody: "Möchtest du {{username}} eine Einladung schicken?",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    inviteError: "Diese Einladung konnte nicht gesendet werden.",
    friendStatus: "Freund(in)",
    meLabel: "Ich",
    requestSentStatus: "Anfrage gesendet",
    incomingInviteDialogTitle: "Dieser Freundesgruppe beitreten?",
    incomingInviteDialogBody: "Möchtest du der Gruppe {{groupName}} beitreten?",
    leaveGroup: "Gruppe verlassen",
    leaveDialogTitle: "Gruppe verlassen",
    leaveDialogBody: "Du kannst später jederzeit zurückkommen, wenn dich jemand erneut einlädt.",
  },
  inviteFriends: {
    pageTitle: "Lade deine Freunde ein",
    popupTitle: "Lade deine Freunde zu Qubiq ein",
    popupBodyBeforeReward: "Du und dein Freund bekommt",
    popupBodyAfterReward: "wenn er sich über deinen Link anmeldet.",
    messageLabel: "Nachricht",
    copyIconLabel: "Kopieren",
    rewardLine: "20 qubs für deinen Freund und 20 qubs für dich",
    helper:
      "Wähle Kontakte aus, wenn dein Gerät das unterstützt. Andernfalls öffnet Qubiq das Teilen deines Geräts oder kopiert die Nachricht.",
    cta: "Meine Freunde einladen",
    copyButton: "Nachricht kopieren",
    copied: "Nachricht kopiert",
    loadError: "Dein Einladungslink konnte nicht vorbereitet werden.",
    actionError: "Die Einladung konnte nicht geöffnet werden.",
  },
  cookieConsent: {
    bannerTitle: "Qubiq verwendet Cookies",
    bannerDescription:
      "Wir verwenden Tracker, die für den Betrieb des Dienstes notwendig sind, und mit deiner Einwilligung Cookies zur Reichweitenmessung, um die Nutzung von Qubiq besser zu verstehen.",
    bannerDetails:
      "Du kannst zustimmen, ablehnen oder deine Auswahl anpassen. Ablehnen ist genauso einfach wie zustimmen, und du kannst deine Präferenzen später ändern.",
    customize: "Anpassen",
    refuseAll: "Alles ablehnen",
    acceptAll: "Alles akzeptieren",
    preferencesTitle: "Meine Cookies verwalten",
    preferencesDescription:
      "Wähle aus, welche Tracker auf Qubiq verwendet werden dürfen. Notwendige Cookies bleiben aktiv, um Anmeldung, Sicherheit und wesentliche Funktionen des Dienstes zu ermöglichen.",
    analyticsNotice:
      "Google Analytics bleibt deaktiviert, bis du der Reichweitenmessung zustimmst.",
    necessaryTitle: "Notwendige Cookies",
    necessaryDescription:
      "Anmeldung, Sicherheit, Sitzungsstabilität und unverzichtbare technische Funktionen.",
    analyticsTitle: "Reichweitenmessung",
    analyticsDescription:
      "Google Analytics 4 zur Messung von Traffic, Leistung und der allgemeinen Nutzung von Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Kategorie für zukünftige Marketing-Nutzungen. Sie bleibt vorerst deaktiviert.",
    cancel: "Abbrechen",
    saveChoices: "Meine Auswahl speichern",
  },
  navigation: {
    profile: "Profil",
    home: "Start",
    infoAndRules: "Infos und Regeln",
    creatorsShow: "Unsere Creator liefern die Show",
    explore: "Explore",
    rankings: "Rankings",
  },
  sidebar: {
    hangout: "Dort, wo alle abhängen",
    welcomeCommunity: "Willkommen in der Community",
  },
  categories: {
    entertainment: "Unterhaltung",
    quiz: "Quiz und Lernen",
    science: "Wissenschaft einfach erklärt",
    sport: "Sport",
    esport: "Esport",
    music: "Musik",
  },
  visibility: {
    public: "Öffentlich",
    notListed: "Nicht gelistet",
    private: "Privat",
  },
  ranking: {
    rankingGeneral: "Gesamtrangliste",
    progression: "Fortschritt",
    rankings: "Rankings",
    exploreRankings: "Explore-Rankings",
    players: "Spieler",
    channels: "Kanäle",
    loading: "Ranking wird geladen...",
    irlQuest: "IRL-Quest",
    overall: "Gesamt",
    rules: {
      useCase: "Anwendungsfall",
      reward: "Belohnung",
      info: "Info",
      quizVictoryLabel: "Quiz-Sieg",
      quizVictoryInfo: "Nur einmal pro Spiel vergeben.",
      questionAnswerVictoryLabel: "Frage-Antwort-Sieg",
      questionAnswerVictoryInfo: "Nur einmal pro Spiel vergeben.",
      defeatLabel: "Niederlage",
      defeatInfo: "Bei Timeout: 0 XP",
      questCompletedLabel: "Quest abgeschlossen",
      questCompletedInfo: "Bei jedem abgeschlossenen Quest vergeben",
      creatorGamePlayLabel: "Spiel auf deinen Inhalten gespielt",
      creatorGamePlayInfo: "Nur einmal pro Dreierkombination aus Creator, Spiel und Spieler, Sieg oder Niederlage",
      exploreLikeReceivedLabel: "Like auf dein Explore",
      exploreLikeReceivedInfo: "Nur einmal pro Nutzer und pro Explore vergeben",
      exploreViewReceivedLabel: "Aufruf deines Explore",
      exploreViewReceivedInfo: "Für jede neue qualifizierte Sitzung vergeben",
    },
  },
  profile: {
    notFound: "Profil nicht gefunden.",
    loadError: "Dieses Profil konnte nicht geladen werden.",
    signInToSubscribe: "Melde dich an, um zu abonnieren.",
    subscribeFailed: "Das Abonnement ist fehlgeschlagen.",
    deletePostFailed: "Dieser Beitrag kann nicht gelöscht werden.",
    likePostFailed: "Dieser Beitrag kann nicht geliked werden.",
    updateQubsVisibilityFailed: "Die Sichtbarkeit der Qubs konnte nicht aktualisiert werden.",
    videos: "Videos",
    explores: "Explores",
    treasureHunts: "IRL-Quests",
    history: "Verlauf",
    wallet: "Wallet",
    noVideosWatched: "Noch keine Videos angesehen.",
    viewedDuration: "{{duration}} angesehen",
  },
  bannerCounter: {
    loadError: "Wallet konnte nicht geladen werden.",
    offline: "offline",
  },
  studio: {
    explorePublicGpsRequired: "Verknüpfe dieses Explore mit einem GPS-Standort, bevor du es öffentlich machst.",
    explorePrivateGpsRequired: "Verknüpfe dieses Explore mit einem GPS-Standort, bevor du privaten Zugriff gewährst.",
    title: "Qubiq Studio",
    createAction: "Erstellen",
    viewChannel: "Mein Profil ansehen",
    subtitle: "Verwalte deinen Kanal, lade deine Videos hoch und konfiguriere deine Spiele",
    loading: "Lädt...",
    signInRequired: "Melde dich an, um auf Studio zuzugreifen.",
    channel: "Kanal",
    profile: "Mein Profil bearbeiten",
    questsAndExplores: "Quests & Explores",
    videos: "Videos",
    explores: "Explores",
    exploresDescription:
      "Explores sind kurze Videos, die du an bestimmten Orten platzieren kannst.\n\nSpeichere die GPS-Position eines Ortes, den du entdeckst, und verstecke dort dann einen Explore oder einen Schritt einer IRL-Quest.",
    treasureHunts: "IRL-Quests",
    myChannel: "Mein Kanal",
    archives: "Archive",
    statusUploading: "Upload läuft",
    statusProcessing: "Verarbeitung",
    statusReady: "Bereit",
    statusError: "Fehler",
    gpsPosition: "GPS-Position",
    manageGpsPoints: "Meine GPS-Punkte verwalten",
    manageGpsPointsDescription: "Finde, benenne um und lösche die für deine Explores gespeicherten GPS-Positionen.",
    backToExplores: "Zurück zu Explores",
    gpsPointSearchPlaceholder: "GPS-Punkt nach Namen suchen",
    gpsPointLabel: "Name des GPS-Punkts",
    unnamedGpsPoint: "Unbenannter GPS-Punkt",
    noGpsPoints: "Noch keine GPS-Punkte gespeichert.",
    noGpsPointSearch: "Kein GPS-Punkt entspricht dieser Suche.",
    gpsPointInUse: "Wird von {{count}} Explore(s) verwendet",
    gpsPointUnused: "Dieser Punkt wird von keinem Explore verwendet.",
    deleteGpsPoint: "Punkt löschen",
    gpsPointDeleteQuestion: "\"{{label}}\" endgültig löschen?",
    gpsPointDeleteBlocked: "Dieser Punkt wird von {{count}} Explore(s) verwendet. Entferne ihn zuerst aus diesen Explores.",
    loadMoreGpsPoints: "Mehr Punkte laden",
    gpsPointsCount: "{{count}} GPS-Punkt(e)",
    gpsMapUnavailable: "Die Maps-Vorschau ist nicht verfügbar. Die Koordinaten werden weiterhin oben angezeigt.",
    laptop: "Laptop",
    tablet: "Tablet",
    smartphone: "Smartphone",
    durationCheckError: "Die Dauer dieses Videos konnte nicht geprüft werden.",
    uploadFinishedProcessing: "Upload abgeschlossen. Qualitätsverarbeitung und Kodierung laufen.",
    verticalPreviewInfo: "Für Explores wird nur eine vertikale Vorschau angezeigt.",
    saving: "Speichern...",
    save: "Speichern",
    saveGame: "Spiel speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    editPhoto: "Foto bearbeiten",
    savingProfile: "Speichern...",
    saveProfile: "Profil speichern",
    noGamesConfigured: "Kein Spiel konfiguriert.",
    noArchivedExplore: "Zurzeit kein archivierter Explore.",
    noArchivedVideo: "Zurzeit kein archiviertes Video.",
    noArchivedExploreSearch: "Kein archivierter Explore passt zu dieser Suche.",
    noArchivedVideoSearch: "Kein archiviertes Video passt zu dieser Suche.",
    loadingVideos: "Videos werden geladen...",
    noExploreYet: "Zurzeit kein Explore.",
    noVideoYet: "Zurzeit kein Video.",
    noExploreSearch: "Kein Explore passt zu dieser Suche.",
    noVideoSearch: "Kein Video passt zu dieser Suche.",
    noDescription: "Keine Beschreibung.",
    untitled: "Ohne Titel",
    confirm: "Bestätigen",
    loadingAccess: "Zugriffe werden geladen...",
    noLinkedAccount: "Zurzeit kein verknüpftes Konto",
    close: "Schließen",
    quizFirstTwoAnswersRequired: "Die ersten beiden Antworten sind für {{game}} erforderlich.",
    chooseCorrectAnswer: "Wähle die richtige Antwort.",
    correctAnswerMustBeFilled: "Die richtige Antwort muss auf eine ausgefüllte Antwort verweisen.",
    shortAnswerRequired: "Die richtige Antwort ist für {{game}} erforderlich.",
    configureChannel: "Meinen Kanal konfigurieren",
    profilePhotoAlt: "Profilbild",
    firstName: "Vorname",
    lastName: "Nachname",
    username: "Benutzername",
    bio: "Bio",
    channelName: "Name deines Kanals",
    channelNameHelper: "Erforderlich, um ein Video hochzuladen.",
    channelDescription: "Beschreibung deines Kanals",
    statusLabel: "Status",
    draftStatus: "Entwurf",
    publishedStatus: "Veröffentlicht",
    authorizedEmailsLabel: "Autorisierte E-Mails",
    authorizedEmailsHelper: "Eine E-Mail pro Zeile oder durch Kommas getrennt.",
    titleLabel: "Titel",
    categoryLabel: "Kategorie",
    visibilityLabel: "Sichtbarkeit",
    descriptionLabel: "Beschreibung",
    archivedVideosTab: "Videos",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Ein archiviertes Video nach Titel suchen",
    archivedExploreSearchPlaceholder: "Einen archivierten Explore nach Titel suchen",
    videoSearchPlaceholder: "Ein Video nach Titel suchen",
    exploreSearchPlaceholder: "Einen Explore nach Titel suchen",
    removeFromArchives: "Aus dem Archiv entfernen",
    addVideo: "Ein Video hinzufügen",
    addExplore: "Einen Explore hinzufügen",
    refresh: "Aktualisieren",
    archive: "Archivieren",
    changeThumbnail: "Vorschaubild ändern",
    uploadThumbnail: "Vorschaubild wird hochgeladen...",
    managePrivateAccess: "Private Zugriffe verwalten",
    authorizedEmailsCount: "{{count}} autorisierte E-Mail(s)",
    addEmails: "Eine oder mehrere E-Mails hinzufügen",
    add: "Hinzufügen",
    validate: "Bestätigen",
    viewVideo: "Video ansehen",
    dateLabel: "Datum",
    viewsLabel: "Aufrufe",
    configureGame: "{{game}} konfigurieren",
    editGame: "{{game}} bearbeiten",
    gameMoment: "Zeitpunkt",
    gameStartTimecode: "Start-Timecode",
    gameEndTimecode: "End-Timecode",
    timeFormatHelper: "Verwende 00:00 oder 00:00:00.",
    gameStartsAt: "Das Spiel startet zu diesem Zeitpunkt.",
    gameEndsAt: "Das Spiel endet zu diesem Zeitpunkt.",
    answerTime: "Antwortzeit",
    secondsToAnswer: "Sekunden zum Antworten",
    timecodeReference: "Timecode-Referenz",
    gameStartReference: "Start-Timecode des Spiels",
    gameEndReference: "End-Timecode des Spiels",
    question: "Frage",
    answerOne: "Antwort 1",
    answerTwo: "Antwort 2",
    answerThree: "Antwort 3",
    answerFour: "Antwort 4",
    correctAnswer: "Richtige Antwort",
    expectedAnswer: "Erwartete Antwort",
    expectedAnswerHelper: "Die Antwort des Spielers wird vor dem Vergleich normalisiert.",
    successMessage: "Erfolgsmeldung",
    failureMessage: "Fehlermeldung",
    globalPauseModeActive:
      "Globale Konfiguration aktiv: Der Pausenmodus wird auf Videoebene festgelegt",
    pauseVideoDuringGame: "Video während des Spiels pausieren",
    hardcoreAnswersGlobal:
      "Hardcore-Modus aktiv: Mehrfachantworten werden global festgelegt",
    allowMultipleAnswers: "Mehrere Antworten erlauben",
    hardcoreRegainGlobal:
      "Hardcore-Modus aktiv: Wiedergewinn wird global festgelegt",
    enableMultipleAnswersFirst:
      "Aktiviere zuerst Mehrfachantworten, um Wiedergewinn zu erlauben",
    allowRegainEachVictory: "Wiedergewinn bei jedem Sieg erlauben",
    globalGameConfig: "Globale Konfiguration für die Spiele dieses Videos",
    hardcoreWholeVideo: "Hardcore-Modus für das ganze Video",
    pauseAllGames: "Video bei allen Spielen dieses Videos pausieren",
    pauseCannotDisable: "Die Videopause kann derzeit nicht deaktiviert werden.",
    overlappingGamesWithoutPause: "Diese Spiele würden sich ohne Pause überschneiden:",
    allowMultipleAnswersAllHardcore:
      "Mehrere Antworten bei allen Hardcore-Spielen erlauben",
    allowRegainAllHardcore: "Wiedergewinn bei allen Hardcore-Spielen erlauben",
    hardcoreGlobalAllocation:
      "Der Hardcore-Modus erzwingt eine globale Zuteilung. Replay und Wiedergewinn werden oben festgelegt.",
    applyToAllGames: "Auf alle Spiele anwenden",
    addGame: "Ein Spiel hinzufügen",
    removeGameError: "Das Spiel kann nicht gelöscht werden.",
    removeGameFailed: "Das Spiel konnte nicht gelöscht werden.",
    gameDisabled: "Spiel deaktiviert.",
    disableGame: "Deaktivieren",
    irlQuestCardLabel: "IRL-Quest",
    newTreasureHunt: "Neue IRL-Quest",
    treasureHuntsLoadError: "Die IRL-Quests konnten nicht geladen werden.",
    treasureHuntCreated: "IRL-Quest erstellt.",
    treasureHuntSaved: "IRL-Quest gespeichert.",
    treasureHuntDeleted: "IRL-Quest gelöscht.",
    availableExploresLoadError: "Die verfügbaren Explores konnten nicht geladen werden.",
    exploresAddedToQuest: "Explores zur IRL-Quest hinzugefügt.",
    reorderExploresError: "Die Explores konnten nicht neu angeordnet werden.",
    exploreRemovedFromQuest:
      "Explore aus der IRL-Quest entfernt. Wenn er öffentlich ist, erscheint er wieder auf der normalen Karte.",
    removeExploreFromQuestError: "Dieser Explore kann nicht entfernt werden.",
    treasureHuntThumbnailUpdated: "Quest-Vorschaubild aktualisiert.",
    configureTreasureHunt: "Wähle eine IRL-Quest aus, um sie zu konfigurieren.",
    treasureHuntName: "Name der Quest",
    addExistingExplores: "Vorhandene Explores hinzufügen",
    noExploreInTreasureHunt: "In dieser IRL-Quest gibt es derzeit keinen Explore.",
    noCategory: "Ohne Kategorie",
    moveUp: "Nach oben",
    moveDown: "Nach unten",
    remove: "Entfernen",
    savingTreasureHunt: "Speichern...",
    saveTreasureHunt: "Quest speichern",
    delete: "Löschen",
    treasureHuntsDescription:
      "IRL-Quests sind Explore-Routen, die Schritt für Schritt absolviert werden.\n\nDie Spieler müssen jeden Ort finden und die Spiele in jedem Explore schaffen, um alle Etappen freizuschalten.",
    createNewExplore: "Neuen Explore erstellen",
    createTreasureHunt: "IRL-Quest erstellen",
    searchTreasureHunt: "Eine Quest nach ihrem Titel suchen",
    treasureHuntCount: "{{count}} Explore(s)",
    noTreasureHuntYet: "Derzeit gibt es noch keine IRL-Quest.",
    noTreasureHuntSearch: "Keine IRL-Quest passt zu dieser Suche.",
    signInToStartTreasureHunt: "Melde dich an, um die Quest zu starten.",
    replayable: "Wiederholbar",
    oneAttempt: "Ein Versuch",
    addExistingExploresTitle: "Vorhandene Explores hinzufügen",
    outsideMapWarning:
      "Explores, die bereits mit einer anderen IRL-Quest verknüpft sind, werden aus ihrer aktuellen Quest entfernt.",
    loadingAvailableExplores: "Verfügbare Explores werden geladen...",
    noAvailableExplore: "Kein verfügbarer Explore zum Hinzufügen.",
    deleteTreasureHuntTitle: "Quest löschen",
    deleteTreasureHuntDescription:
      "Diese Aktion löscht die IRL-Quest dauerhaft, ohne die zugehörigen Explores zu löschen.",
    deleting: "Löschen...",
  },
  languageDialog: {
    title: "Sprache",
    description:
      "Wähle die auf Qubiq verwendete Sprache. Wenn die Browsersprache nicht unterstützt wird, verwendet die Anwendung automatisch Englisch.",
    close: "Schließen",
  },
  legalLinks: {
    terms: "Bedingungen",
    legal: "Impressum",
    privacy: "Datenschutz",
    cookies: "Cookies",
    moderation: "Moderation",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
